import { NgModule } from '@angular/core';
import { NoPreloading, RouterModule, Routes } from '@angular/router';
import { NotFoundComponent } from './not-found/not-found.component';
import { OrgTermsConditionsComponent } from './shared/org-terms-conditions/org-terms-conditions.component';
import { UnauthorizedComponent } from './shared/unauthorized/unauthorized.component';
import { GenerateAiDietComponent } from './diet/components/generate-ai-diets/generate-ai-diets.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./tabs/tabs.module').then( m => m.TabsPageModule),
  },
  {
    path: 'appointments',
    loadChildren: () => import('./appointments/appointments.module').then(m => m.AppointmentsModule)
  },
  {
    path: 'user',
    loadChildren: () => import('./user/user.module').then(m => m.UserModule)
  },
  {
    path: 'shop',
    loadChildren: () => import('./shop/shop.module').then(m => m.ShopModule)
  },
  {
    path: 'shared',
    loadChildren: () => import('./shared/shared.module').then(m => m.SharedModule)
  },
   {
    path: 'client-review',
    loadChildren: () => import('./client-review/client-review.module').then(m => m.ClientReviewModule)
  },
  {
    path: 'content',
    loadChildren: () => import('./content/content.module').then(m => m.ContentModule)
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: '',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'shared/org-terms-conditions',
    component: OrgTermsConditionsComponent
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent
  },
  {
    path: 'generate-ai-diets',
    component: GenerateAiDietComponent
  },
  {
    path: '**',
    component: NotFoundComponent
  },
  {
    path: 'generate-ai-diets/:tab',
    component: GenerateAiDietComponent
  }
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: NoPreloading  })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
